import { render, staticRenderFns } from "./SocialReviewAnswerReviewModal.vue?vue&type=template&id=89fc4a60&scoped=true&"
import script from "./SocialReviewAnswerReviewModal.vue?vue&type=script&lang=js&"
export * from "./SocialReviewAnswerReviewModal.vue?vue&type=script&lang=js&"
import style0 from "./SocialReviewAnswerReviewModal.vue?vue&type=style&index=0&id=89fc4a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fc4a60",
  null
  
)

export default component.exports